import React from "react";
import styled from "styled-components";
import {SearchResultIcon} from "./SearchResultIcon";
import {AuthorName, CompanyName} from "./Names";

const Container = styled.div`
    display: flex;
    align-items: center;
`;

export const AuthorSuggestion = ({data, isHighlighted}) => {
    const {firstName, lastName, companyName} = data;

    return <Container>
        <SearchResultIcon type="AUTHOR" isHighlighted={isHighlighted}/>
        <AuthorName className="t-author-name">
            {firstName} {lastName}
        </AuthorName>
        <CompanyName className="t-company-name" isHighlighted={isHighlighted} width={300} marginRight={8}>
            {companyName}
        </CompanyName>
    </Container>;
};